import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Visit } from 'src/app/assabil-kernel/models/entities/master-data/visit-entity';
import { KpiHistory } from '../models/dtos/kpi-history';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { GeoAreaLoyaltyProgramKpi } from '../models/dtos/geo-area-loyalty-program-kpi';


@Injectable({
    providedIn: 'root'
})
export class SalesMonitoringService {


    constructor(
        private networkService: LeanNetworkService,
        public userService : UserService) {

    }
/*
    //------------------------------------------------------------------------------------
    // Branchs Get
    //------------------------------------------------------------------------------------
    branchsGet(): Promise<any[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        return new Promise((resolve, reject) => {
            this.networkService.post('kernel/controls/branchsGet', request).then(result => {
                return resolve(result.branchs);
            }, error => {
                reject(error);
            });
        });
    }

    //------------------------------------------------------------------------------------
    // Roles Get
    //------------------------------------------------------------------------------------
    rolesGet(branchCode :string, date : Date): Promise<any[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);

        request.strArg1 = branchCode;
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('kernel/masters/rolesGet', request).then(result => {
                return resolve(result.roles);
            }, error => {
                reject(error);
            });
        });
    }
*/
    getRoleKpis(roleCode : string,  profileCategoryCode : string, date : Date, basedOnInvoice : boolean , basedOnOrder : boolean): Promise<Role> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = roleCode;
        request.dteArg1 = date;
        request.blnArg1 = basedOnInvoice;  
        request.blnArg2 = basedOnOrder; 
        request.strings = [];
        request.strings.push(profileCategoryCode);

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/supervision/roleKpisGet', request).then(result => {
                return resolve(result.role);
            }, error => {
                reject(error);
            });
        });
    }


    getRoleVisits(roleCode: string, date: Date, basedOnInvoice : boolean , basedOnOrder : boolean) : Promise<Visit[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = roleCode;
        request.dteArg1 = date;
        request.blnArg1 = basedOnInvoice;  
        request.blnArg2 = basedOnOrder;  

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/supervision/roleVisitsGet', request).then(result => {
                return resolve(result.visits);
            }, error => {
                reject(error);
            });
        });
    }
    
x
    kpiHistorysGet(roleCode : string,  startDate : Date, endDate : Date, basedOnInvoice : boolean , basedOnOrder : boolean): Promise<KpiHistory[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = roleCode;
        request.dteArg1 = startDate;
        request.dteArg2 = endDate;
        request.blnArg1 = basedOnInvoice;  
        request.blnArg2 = basedOnOrder; 

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/supervision/kpiHistorysGet', request).then(result => {
                return resolve(result.kpiHistorys);
            }, error => {
                reject(error);
            });
        });
    }

}
